// extracted by mini-css-extract-plugin
export default {"sortBlock":"sortBlock_sortBlock__govGG"};